// ==============================================
// FEATURE FLAGS CONFIGURATION
// ==============================================
// Este archivo centraliza todas las feature flags del proyecto.
// Útil para habilitar/deshabilitar funcionalidades en desarrollo
// o preparar features para releases graduales.

export const FEATURE_FLAGS = {
  // ==============================================
  // ONBOARDING FEATURES
  // ==============================================

  /**
   * Habilita el sistema de contacto para solicitar CSV de bulk locations
   * Cuando esté en true, muestra el texto de ayuda con link para contactar soporte
   * cuando el usuario necesita más de 5 locaciones adicionales.
   *
   * Opciones futuras a implementar:
   * - EmailJS con modal profesional
   * - WhatsApp Business integration
   * - Contact form con backend API
   * - Live chat (Intercom/Zendesk)
   *
   * @type {boolean}
   * @default false
   */
  ENABLE_BULK_LOCATIONS_CONTACT: false,

  // ==============================================
  // FUTURE FEATURES (Ejemplos)
  // ==============================================

  // ENABLE_NEW_DASHBOARD: false,
  // ENABLE_ANALYTICS: false,
  // ENABLE_NOTIFICATIONS: false,
};

export default FEATURE_FLAGS;
